
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"xmlns":"http://www.w3.org/2000/svg","viewBox":"0 0 36 36"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M27.433 17.875l5.33 3.115L18 29.596 3.238 20.99l5.33-3.115-5.33-3.041L18 6.404l14.762 8.43-5.329 3.04zm-2.155 1.24L18 23.278l-7.277-4.163-3.204 1.875L18 27.101l10.481-6.111-3.203-1.875zM18 8.855L7.52 14.76 18 20.827l10.481-5.993-10.48-5.979z","fill":"#000","fill-rule":"evenodd"}})])
          )
        }
      }
    